import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
type UseAutosizeTextAreaProps = {
  textAreaRef: React.MutableRefObject<HTMLTextAreaElement | null>;
  minHeight?: number;
  maxHeight?: number;
  triggerAutoSize: string;
};
export const useAutosizeTextArea = t0 => {
  const $ = _c(9);
  const {
    textAreaRef,
    triggerAutoSize,
    maxHeight: t1,
    minHeight: t2
  } = t0;
  const maxHeight = t1 === undefined ? Number.MAX_SAFE_INTEGER : t1;
  const minHeight = t2 === undefined ? 0 : t2;
  const hasInitializedRef = useRef(false);
  let t3;
  if ($[0] !== maxHeight || $[1] !== minHeight || $[2] !== textAreaRef) {
    t3 = () => {
      const textAreaElement = textAreaRef.current;
      if (textAreaElement) {
        if (!hasInitializedRef.current) {
          textAreaElement.style.setProperty("min-height", `${minHeight + 0}px`);
          if (maxHeight > minHeight) {
            textAreaElement.style.setProperty("max-height", `${maxHeight}px`);
          }
          hasInitializedRef.current = true;
        }
        textAreaElement.style.setProperty("height", `${minHeight + 0}px`);
        const scrollHeight = textAreaElement.scrollHeight;
        if (scrollHeight > maxHeight) {
          textAreaElement.style.setProperty("height", `${maxHeight}px`);
          textAreaElement.style.setProperty("overflow-y", "scroll");
        } else {
          textAreaElement.style.setProperty("height", `${scrollHeight + 0}px`);
          textAreaElement.style.setProperty("overflow-y", "hidden");
        }
      }
    };
    $[0] = maxHeight;
    $[1] = minHeight;
    $[2] = textAreaRef;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== maxHeight || $[5] !== minHeight || $[6] !== textAreaRef || $[7] !== triggerAutoSize) {
    t4 = [textAreaRef, triggerAutoSize, minHeight, maxHeight];
    $[4] = maxHeight;
    $[5] = minHeight;
    $[6] = textAreaRef;
    $[7] = triggerAutoSize;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
};